import React from "react";
import * as styles from "./screen-content-container.module.scss";
import { classArr } from "../helper/style-helper";

export interface ScreenContentContainerProps {
	className?: string;
	children?: React.ReactNode;
}

export function ScreenContentContainer(props: ScreenContentContainerProps) {
	return (
		<div className={classArr(styles.container, props.className)}>
			{props.children}
		</div>
	);
}
